(function() {
  const SCROLL_THRESHOLD = 1000; // Show after 1000px
  const stickyBar = document.querySelector('.sticky-atc-bar');
  
  if (!stickyBar) {
    console.warn('Sticky bar not found');
    return;
  }
  
  // Add m-hidden class initially if not already present
  if (window.scrollY < SCROLL_THRESHOLD) {
    stickyBar.classList.add('m-hidden');
  }
  
  function handleScroll() {
    const scrollY = window.scrollY || window.pageYOffset;
    
    if (scrollY >= SCROLL_THRESHOLD) {
      // Remove m-hidden class - show the bar
      stickyBar.classList.remove('m-hidden');
      console.log('Sticky bar shown at', scrollY, 'px');
    } else {
      // Add m-hidden class - hide the bar
      stickyBar.classList.add('m-hidden');
      console.log('Sticky bar hidden at', scrollY, 'px');
    }
  }
  
  // Listen to scroll events
  window.addEventListener('scroll', handleScroll, { passive: true });
  
  // Initial check
  handleScroll();
  
  console.log('Sticky bar scroll toggle initialized - threshold:', SCROLL_THRESHOLD, 'px');
})();
function aggiornaData() {
  const joursDeLaSemaine = ["Dim.", "Lun.", "Mar.", "Mer.", "Jeu.", "Ven.", "Sam."];
  const mois = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
  
  const maintenant = new Date();
  const demain = new Date(maintenant);
  demain.setDate(maintenant.getDate() + 1);
  
  const dateFormatee = `${joursDeLaSemaine[demain.getDay()]} ${demain.getDate()} ${mois[demain.getMonth()]}`;
  
  const cstmDate = document.getElementById('cstmdate');
  if (cstmDate) {
    cstmDate.innerText = dateFormatee;
  }

  const msJusquaMinuit = new Date(maintenant.setHours(24, 0, 0, 0)) - maintenant;
  setTimeout(() => {
    aggiornaData();
    setInterval(aggiornaData, 24 * 60 * 60 * 1000);
  }, msJusquaMinuit);
}

aggiornaData();
function initcollectionSlider() {
  var swiper = new Swiper(".McollectionSlider", {
    slidesPerView: 2, 
    loop: true,
    spaceBetween: 15,
    autoplay: {
      delay: 500,
      disableOnInteraction: true,
    },
    speed: 1000,    
    navigation: {
      nextEl: ".m-cs-next",
      prevEl: ".m-cs-prev",
      hideOnClick: false,
      disabledClass: "swiper-button-disabled",
      lockClass: "swiper-button-lock"
    },
    pagination: {
        el: ".swiper-pagination",
    },
    breakpoints: {
      1000: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      0: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
    },
  });
}
function initcollectiontabsSlider() {
  var swiper = new Swiper(".MClslider", {
    slidesPerView: 2, 
    // loop: true,
    spaceBetween: 15,
    // autoplay: {
    //   delay: 500,
    //   disableOnInteraction: true,
    // },
    speed: 1000,    
    navigation: {
      nextEl: ".m-cl-next",
      prevEl: ".m-cl-prev",
      hideOnClick: false,
      disabledClass: "swiper-button-disabled",
      lockClass: "swiper-button-lock"
    },
    pagination: {
        el: ".swiper-pagination",
    },
    breakpoints: {
      1000: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      0: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
    },
  });
}
document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector('.m-collection-tabs');
  if (!section) return;

  const tabs = section.querySelectorAll('.m-ct-tab-btn');
  const collections = section.querySelectorAll('.m-ct-collection');

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('active'));
      collections.forEach(c => c.style.display = 'none');

      tab.classList.add('active');
      collections[index].style.display = 'block';
      initcollectiontabsSlider();
    });
  });
  if (tabs.length > 0) {
    tabs[0].classList.add('active');
    collections.forEach((c, i) => c.style.display = i === 0 ? 'block' : 'none');
    initcollectiontabsSlider();
  }
});


function reviewSlider() {
    var swiper = new Swiper(".MreviewSlider", {
        slidesPerView: 1,
        spaceBetween: 15,
        loop: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: ".m-swiper-next",
            prevEl: ".m-swiper-prev",
        },
        breakpoints: {
            0: { slidesPerView: 1, spaceBetween: 15 },
            840: { slidesPerView: 2, spaceBetween: 15 },
            1050: { slidesPerView: 3, spaceBetween: 15 },
            1200: { slidesPerView: 4, spaceBetween: 15 },
        },
    });
}